import moment from 'moment-timezone';

export function formatDateTimeData(types = [], dateTime = [], timezone, dateTimeFormatSmall) {
  const formatted = {};

  if (!Array.isArray(dateTime) || dateTime.length === 0 || !timezone) {
    return formatted;
  }

  types.forEach((type, index) => {
    const dt = dateTime[index];
    if (!dt) return;

    const converted = moment.utc(dt).tz(timezone);

    const getDayWithSuffix = (day) => {
      const suffixes = ["th", "st", "nd", "rd"];
      const v = day % 100;
      return day + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };

    formatted[type] = {
      day: getDayWithSuffix(converted.date()),
      month: converted.format('MMM'),
      year: converted.year(),
      time: converted.format('HH:mm'),
      small: dateTimeFormatSmall
        ? `${converted.format("DD")}/${converted.format("MM")}/${converted.format("YYYY")}`
        : ''
    };
  });

  return formatted;
}
